import { getStoreState } from '@cogitate/ui-multi-utils';
import { IMAGES_PATH_HELPER } from 'ui/utilities/staticAssetsPaths';
import { storeKeys } from './keys';

const getHREFForClientLob = (key) => {
  try {
    const { [key]: route = '' } = getStoreState(storeKeys.ApplicationReducer)?.SelectedLineLob?.MenusHREF || {};
    return route;
  } catch (error) {
    console.warn(`Error fetching HREF for client LOB: ${error}`);
    return undefined;
  }
};

const Menus = [
  {
    Key: 'AccountHub',
    Label: 'Account Hub',
    Src: `${IMAGES_PATH_HELPER}/sidebar-uiElement.png`,
    Href: getHREFForClientLob('AccountHub') || '/dashboard/accounthub',
    Childs: [],
  },
  {
    Key: 'Renewals',
    Label: 'Renewals',
    Src: `${IMAGES_PATH_HELPER}/renewals.svg`,
    Href: getHREFForClientLob('Renewals') || '/dashboard/renewals',
    Childs: [],
  },
  {
    Key: 'GenerateQuote',
    Label: 'Start Submission',
    Src: `${IMAGES_PATH_HELPER}/sidebar-form.png`,
    Href: getHREFForClientLob('GenerateQuote') || '/quote/quoteindication',
    Childs: [],
  },
  {
    Label: 'Reports',
    Key: 'Reports',
    Href: `${process.env.NEXT_PUBLIC_REPORT_URL}`,
    Src: `${IMAGES_PATH_HELPER}/Underwriter Analytics.png`,
    Childs: [],
  },
  // {
  //   Key: 'Analytics',
  //   Label: 'Analytics',
  //   Src: `${IMAGES_PATH_HELPER}/analyticsicon.png`,
  //   Href: getHREFForClientLob('Analytics') || '/dashboard/analytics',
  //   Childs: [],
  // },
  {
    Key: 'MyCommunicationHub',
    Label: 'My Communication Hub',
    Src: `${IMAGES_PATH_HELPER}/communication.png`,
    Href: '/dashboard/my-communication-hub',
    Childs: [],
  },
];
export { Menus };
